import { createSlice } from "@reduxjs/toolkit";
import { getTotalCertifications, getTotalClientAdmin, getTotalClientAuditors, getTotalClients, getTotalClientUsers, getTotalUsers } from "./thunk";

const dashboardWidgetDataSlice = createSlice({
    name: "getCCFFilterList",
    initialState: {
        isLoading: false,
        isError: false,
        totalClients: [],
        totalUsers: [],
        totalClientAdmin: [],
        totalClientUsers: [],
        totalClientAuditors: [],
        totalCertifications: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getTotalClients.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getTotalClients.fulfilled, (state, action) => {
            state.isLoading = false;
            state.totalClients = action.payload;
        });
        builder.addCase(getTotalClients.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

        builder.addCase(getTotalUsers.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getTotalUsers.fulfilled, (state, action) => {
            state.isLoading = false;
            state.totalUsers = action.payload;
        });
        builder.addCase(getTotalUsers.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

        builder.addCase(getTotalClientAdmin.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getTotalClientAdmin.fulfilled, (state, action) => {
            state.isLoading = false;
            state.totalClientAdmin = action.payload;
        });
        builder.addCase(getTotalClientAdmin.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

        builder.addCase(getTotalClientUsers.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getTotalClientUsers.fulfilled, (state, action) => {
            state.isLoading = false;
            state.totalClientUsers = action.payload;
        });
        builder.addCase(getTotalClientUsers.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

        builder.addCase(getTotalClientAuditors.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getTotalClientAuditors.fulfilled, (state, action) => {
            state.isLoading = false;
            state.totalClientAuditors = action.payload;
        });
        builder.addCase(getTotalClientAuditors.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

        builder.addCase(getTotalCertifications.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getTotalCertifications.fulfilled, (state, action) => {
            state.isLoading = false;
            state.totalCertifications = action.payload;
        });
        builder.addCase(getTotalCertifications.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

    }
});

export default dashboardWidgetDataSlice.reducer;